import React from 'react'
import LayoutAdmin from './layoutadmin'
import { inject, observer } from 'mobx-react'
import { withLayoutAdmin } from '../../utils/hoc'
import T from 'i18n-react'

import Paper from 'material-ui/Paper'
import Tabs, { Tab } from 'material-ui/Tabs'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Icon from 'material-ui/Icon'
import Grid from 'material-ui/Grid'
import Card, { CardHeader, CardMedia, CardContent, CardActions } from 'material-ui/Card'
import Avatar from 'material-ui/Avatar'
import IconButton from 'material-ui/IconButton'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import Badge from 'material-ui/Badge'


@inject('admin','adminui') @observer
class Inbox extends React.Component {
 render () {
  const { admin,adminui,classes } = this.props

  let mailIcon =  <Icon>mail</Icon>, trashIcon = <Icon>delete</Icon>
  if (admin.inbox.hasMail) {
    mailIcon =
     <Badge badgeContent={admin.inbox.mails.length} color="secondary">
      <Icon>mail</Icon>
     </Badge>
  }
  if (admin.inbox.hasTrash) {
    trashIcon =
     <Badge badgeContent={admin.inbox.trash.length} color="secondary">
      <Icon>delete</Icon>
     </Badge>
  }

  return (
   <Paper className={classes.root}>
    <Tabs
     value={adminui.inboxTab}
     onChange={this.selectTab}
     indicatorColor="primary"
     textColor="primary"
     centered
    >
     <Tab label={T.translate("admin.inbox.mails")} icon={mailIcon} className={classes.tabSpacing}/>
     <Tab label={T.translate("admin.inbox.trash")} icon={trashIcon} className={classes.tabSpacing}/>
     {admin.inbox.hasDeadlinks && <Tab className={classes.tabSpacing} label={T.translate("admin.inbox.deadlinks")} icon={
       <Badge badgeContent={admin.inbox.deadlinks.length} color="secondary">
        <Icon>error_outline</Icon>
       </Badge>
     } />}
    </Tabs>

    <InboxContent classes={classes} />
   </Paper>

  )
 }

 componentDidMount () {
  this.props.admin.inbox.getInbox()
 }

 selectTab = (e,value) => {
   this.props.adminui.selectInboxTab(value)
 }

}

@inject('admin','adminui') @observer
class InboxContent extends React.Component {
  render () {
    const { adminui,classes } = this.props
    return (
      <Grid container justify="center" direction="row" alignItems="flex-start">
       {adminui.inboxTab === 0 && <Mails classes={classes} />}
       {adminui.inboxTab === 1 && <Trash classes={classes} />}
       {adminui.inboxTab === 2 && <Deadlinks classes={classes} />}
      </Grid>
    )
  }
}


@inject('admin','adminui','ui','store') @observer
class Mails extends React.Component {
  render () {
   const { classes } = this.props, inbox = this.props.admin.inbox
    return (
     <Grid item xs={12} sm={10} md={8} lg={6}>
      {inbox.mails.length === 0 && <Typography component="p" type="display1" style={{textAlign:'center'}}> {T.translate('admin.inbox.noMails')} </Typography>}
      {inbox.mails.map( (item,index) => {
       return <Card
               className={classes.card}
               onClick={this.editItem.bind(this,item)}
               key={"mail-inbox-"+index}
              >
               <CardHeader
                avatar={
                 <Avatar aria-label={"mail-inbox-"+index}>
                  {item.isExample && T.translate("meta.b").toUpperCase()}
                  {item.isCollection && T.translate("meta.s").toUpperCase()}
                 </Avatar>
                }
                title={item.title}
                subheader={item.created}
               />
              </Card>
      })}
     </Grid>
    )
  }

  editItem = (item) => {
   if (item.isExample) {
     this.props.admin.setCurrentExample(item)
     this.props.admin.setExampleFormAsAcceptDecline()
     this.props.ui.newExampleForm.handleOpen()
   }
   if (item.isCollection) {
     this.props.admin.setCurrentCollection(item)
     this.props.admin.setCollectionFormAsAcceptDecline()
     this.props.ui.newCollectionForm.handleOpen()
   }
  }
}


@inject('admin','ui') @observer
class Trash extends React.Component {
  render () {
    const { classes } = this.props, inbox = this.props.admin.inbox
    return (
     <Grid item xs={12} sm={10} md={8} lg={6}>
     {inbox.trash.length === 0 && <Typography component="p" type="display1" style={{textAlign:'center'}}> {T.translate('admin.inbox.noTrash')} </Typography>}
      {inbox.trash.map( (item,index) => {
       return <Card
               className={classes.card}
               onClick={this.openDeleteDialog.bind(this,item)}
               key={"mail-inbox-"+index}
              >
               <CardHeader
                avatar={
                 <Avatar aria-label={"mail-inbox-"+index}>
                  {item.isExample && T.translate("meta.b").toUpperCase()}
                  {item.isCollection && T.translate("meta.s").toUpperCase()}
                 </Avatar>
                }
                title={item.title}
                subheader={item.created}
               />
              </Card>
      })}
     </Grid>
    )
  }

  openDeleteDialog = (item) => {
   if (item.isExample) {
     this.props.admin.setCurrentExample(item)
     this.props.admin.setExampleFormAsDeleteRestore()
     this.props.ui.newExampleForm.handleOpen()
   }
   if (item.isCollection) {
     this.props.admin.setCurrentCollection(item)
     this.props.admin.setCollectionFormAsDeleteRestore()
     this.props.ui.newCollectionForm.handleOpen()
   }
  }

}



@inject('admin','adminui','ui','store') @observer
class Deadlinks extends React.Component {
  render () {
   const { classes } = this.props, inbox = this.props.admin.inbox
    return (
     <Grid item xs={12} sm={10} md={8} lg={6}>
      {inbox.deadlinks.map( (item,index) => {
       return <Card
               className={classes.card}
               onClick={this.updateItem.bind(this,item)}
               key={"deadlink-inbox-"+index}
              >
               <CardHeader
                avatar={
                 <Avatar aria-label={"deadlink-inbox-"+index}>
                  {T.translate("meta.b").toUpperCase()}
                 </Avatar>
                }
                title={item.title}
                subheader={item.created}
               />
              </Card>
      })}
     </Grid>
    )
  }

  updateItem = (item) => {
   if (item.isExample) {
     this.props.admin.setCurrentExample(item)
     this.props.admin.setExampleFormAsUpdate()
     this.props.ui.newExampleForm.handleOpen()
   }
  }
}




const styles = theme => ({
  root:{
    overflow:'hidden'
  },
  card:{
   cursor:"pointer",
   margin:10,
   position:"relative"
  },
  deleltePermBtn:{
   position:"absolute",
   right:15,
   top:15
  },
  tabSpacing:{
    paddingTop:20
  }
})

Inbox.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}


export default withStyles(styles, { withTheme: true })(withLayoutAdmin(Inbox))



// WEBPACK FOOTER //
// ./src/components/admin/inbox.js